import { render, staticRenderFns } from "./ProjectsDataTable.vue?vue&type=template&id=16436744&scoped=true&"
import script from "./ProjectsDataTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsDataTable.vue?vue&type=style&index=0&id=16436744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16436744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCheckbox,VChip})
